import React from 'react'
import View from './view'

const Capacity = ({capacity}) => {
  const {
    attributes
  } = capacity

  return (
    <div className="details-card">
      <h2>Capacity</h2>
      <section>
        {attributes.map((capacity, i) => <View key={`capacity-${i}`} {...capacity} />)}
      </section>
    </div>
  )
}

export default Capacity


// WEBPACK FOOTER //
// ./src/gov-care-registration-details/views/capacity/index.jsx